// extracted by mini-css-extract-plugin
export var button = "ComponentsSlider-module--button--ad51f";
export var buttonDesktopOnly = "ComponentsSlider-module--buttonDesktopOnly--7a784";
export var buttonNoMargin = "ComponentsSlider-module--buttonNoMargin--9199a";
export var hideButton = "ComponentsSlider-module--hideButton--29bc3";
export var hidePaginationList = "ComponentsSlider-module--hidePaginationList--2bc4c";
export var moreLink = "ComponentsSlider-module--moreLink--08f9f";
export var moreLinkImage = "ComponentsSlider-module--moreLinkImage--589ec";
export var pagination = "ComponentsSlider-module--pagination--4398f";
export var paginationList = "ComponentsSlider-module--paginationList--7552e";
export var paginationListDesktopOnly = "ComponentsSlider-module--paginationListDesktopOnly--bc35d";
export var slide = "ComponentsSlider-module--slide--4baf2";
export var swiperSlide = "ComponentsSlider-module--swiperSlide--64220";
export var swiperSlidePaged = "ComponentsSlider-module--swiperSlidePaged--bd302";
export var wedding = "ComponentsSlider-module--wedding--24592";